
import { useState } from "react";

export const useProfileTabs = () => {
  const [activeTab, setActiveTab] = useState("posts");
  const [selectedCropForTimelapse, setSelectedCropForTimelapse] = useState<string | null>(null);
  const [selectedPostForPopup, setSelectedPostForPopup] = useState<any>(null);

  return {
    activeTab,
    setActiveTab,
    selectedCropForTimelapse,
    setSelectedCropForTimelapse,
    selectedPostForPopup,
    setSelectedPostForPopup,
  };
};
